export function preventNegativeZero(number: number): number {
  // 0 === -0 is true. But not true in assert.strictEqual :)
  if (number === 0) {
    return 0;
  }
  return number;
}
